import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { QUOTATIONS_ROUTE } from "./Quotations.constants";
import { MODULE_IDS } from "../../constants/enums";

//************************ Purchase Order Imports ***************************/
const QuotationsTable = Loadable(
  lazy(() =>
    import("./QuotationsTable").then(({ QuotationsTable }) => ({
      default: QuotationsTable,
    })),
  ),
);

const ManageQuotation = Loadable(
  lazy(() =>
    import("./ManageQuotation").then(({ ManageQuotation }) => ({
      default: ManageQuotation,
    })),
  ),
);

//************************ Purchase Order Routes ***************************/
export const quotationsRoutes = [
  {
    path: QUOTATIONS_ROUTE,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.QUOTATION]}>
        <QuotationsTable />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${QUOTATIONS_ROUTE}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.QUOTATION]}>
        <ManageQuotation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${QUOTATIONS_ROUTE}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.QUOTATION]}>
        <ManageQuotation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${QUOTATIONS_ROUTE}/duplicate/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.QUOTATION]}>
        <ManageQuotation isDuplicate />
      </AuthorizedRoute>
    ),
  },
];
